<template>
  <div class="container">
    <van-swipe :loop="false" indicator-color="white">
    
      <van-swipe-item>
        <img src="~@/assect/Welcome3.png" >
        <h5 class="exper"><span class="experience" @click="enter">立即体验</span></h5>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'

export default {
  name: 'IntroPage',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {

    } 
  },
  methods: {
    enter() {
      localStorage.firstload = 1
      this.$router.replace('/login')
    }

  }
}
</script>

<style lang="less" scoped>

.container{
  overflow: hidden;
  height: 100vh;
}
img{
  width: 100vw;
  height: 100vh;
}
.exper{
  position: absolute;
    bottom: 8%;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    font-size: 4.5vw;
  .experience {
    border: 1px solid white;
    padding: 10px 15px;
    max-width: 20vw;

    color: #fff;
    font-weight: 500;
  }
}
</style>
